import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-rich-text-editor-page-ui',
    templateUrl: './bb-rich-text-editor-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbRichTextEditorPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
